export default [
  {
    title: 'Dashboard',
    route: 'home',
    icon: 'HomeIcon',
    permission: ['dashboard'],
  },
  {
    header: 'Order Manage',
    permission: ['create-orders', 'view-orders'],
  },
  {
    title: 'Add New Order',
    route: 'second-page',
    icon: 'PlusCircleIcon',
    permission: ['create-orders'],
  },
  {
    title: 'My Orders',
    route: 'my-orders',
    icon: 'AlignJustifyIcon',
    permission: ['view-orders'],
  },
  {
    title: 'Operations',
    route: 'client-operations',
    icon: 'CodepenIcon',
    permission: ['view-orders', 'add-draft', 'view-draft', 'edit-draft', 'add-confirmed', 'view-confirmed', 'edit-confirmed', 'add-cancelled', 'view-cancelled', 'edit-cancelled', 'add-return-to-client', 'view-return-to-client', 'edit-return-to-client', 'add-received-failed-order', 'view-received-failed-order', 'edit-received-failed-order', 'bulk-update-operation'],
  },
  {
    header: 'Finance',
    permission: ['finance-view'],
  },
  {
    title: 'Overview',
    route: 'merchant-overview',
    icon: 'TrelloIcon',
    permission: ['finance-view'],
  },
  {
    title: 'My Invoices',
    route: 'my-invoice',
    icon: 'LayersIcon',
    permission: ['finance-view'],
  },
  {
    title: 'My Rate Card',
    route: 'my-rate-card',
    icon: 'DollarSignIcon',
    permission: ['finance-view'],
  },
  {
    header: 'Reports ',
    permission: ['finance-report', 'delivery-order-report', 'return-order-report'],
  },
  {
    title: 'Reports',
    icon: 'FileTextIcon',
    permission: ['finance-report', 'delivery-order-report', 'return-order-report'],
    children: [
      {
        title: 'Finance',
        route: 'finance-report',
        icon: '',
        permission: ['finance-report'],
      },
      {
        title: 'Orders',
        icon: '',
        permission: ['delivery-order-report', 'return-order-report'],
        children: [
          {
            title: 'Delivery',
            route: 'delivery-orders',
            icon: '',
            permission: ['delivery-order-report'],
          },
          {
            title: 'Return',
            route: 'return-orders',
            icon: '',
            permission: ['return-order-report'],
          },
        ],
      },
      {
        title: 'Downloads',
        route: 'report-downloads',
        icon: '',
        // permission: ['download-reports'],
      },
    ],
  },
  {
    header: 'Settings ',
    permission: ['view-merchant-business', 'edit-merchant-business', 'view-merchant-address', 'edit-merchant-address', 'view-merchant-contact', 'edit-merchant-contact', 'view-merchant-bank', 'edit-merchant-bank', 'view-merchant-users', 'edit-merchant-users', 'view-role'],
  },
  {
    title: 'Manage',
    icon: 'UsersIcon',
    permission: ['view-merchant-business', 'edit-merchant-business', 'view-merchant-address', 'edit-merchant-address', 'view-merchant-contact', 'edit-merchant-contact', 'view-merchant-bank', 'edit-merchant-bank', 'view-merchant-users', 'edit-merchant-users', 'view-role'],
    children: [
      {
        title: 'Businesses',
        route: 'businesses',
        icon: '',
        permission: ['view-merchant-business', 'edit-merchant-business'],
      },
      {
        title: 'Users',
        route: 'users',
        icon: '',
        permission: ['view-merchant-users', 'edit-merchant-users'],
      },
      {
        title: 'Roles',
        route: 'roles',
        permission: ['view-role'],
        icon: '',
      },
    ],
  },
  {
    title: 'Tickets',
    route: 'tickets',
    icon: 'BookIcon',
    permission: ['create-tickets'],
  },
  {
    title: 'Feedback',
    route: 'feedback',
    icon: 'StarIcon',
  },
  {
    title: 'Waybill Request',
    route: 'waybill-request',
    icon: 'FileMinusIcon',
    permission: ['show-waybill-request'],
  },
  {
    title: 'Settings',
    route: 'business-settings',
    icon: 'SettingsIcon',
    permission: ['view-settings'],
  },
]
